import Button from '@/common/components/Button'
import { ShowHeader } from '@/common/components/ShowHeader'
import { useGoBack } from '@/common/hooks/useGoBack'
import { useMaintenanceWorkflow } from '@/features/maintenanceWorkflow/pages/Create/hooks/useMaintenanceWorkflow'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

interface MaintenanceDirectiveEntryExecutionHeaderProps {
  actions?: JSX.Element
  showCancelButton?: boolean
}

export const MaintenanceDirectiveEntryExecutionHeader = ({
  actions,
  showCancelButton,
}: MaintenanceDirectiveEntryExecutionHeaderProps) => {
  const { id: workflowId } = useParams()

  const goBack = useGoBack()

  const { data: workflow, isPending: workflowIsPending } = useMaintenanceWorkflow(workflowId)

  return (
    <ShowHeader
      goBack
      goBackProps={{
        fallback: `/maintenance-workflows/${workflowId}`,
        searchLastRouteFromFallback: true,
      }}
      isLoading={!!workflowIsPending}
      title="Processos de manutenção"
      subtitle={
        <div className="flex items-center gap-2">
          <p>{workflow?.protocol_number || ''}</p>

          <ChevronsRightIcon />

          <p className="text-white-800">Vistoria</p>
        </div>
      }
      titleClassName="text-md"
      className="text-white-400"
      subtitleClassName="text-nowrap font-medium"
      buttons={
        <div className="flex items-center gap-3">
          {showCancelButton && (
            <Button
              variant="outline-error"
              onClick={() =>
                goBack({
                  fallback: `/maintenance-workflows/${workflowId}`,
                  searchLastRouteFromFallback: true,
                })
              }
            >
              Cancelar
            </Button>
          )}

          {actions}
        </div>
      }
    />
  )
}
